import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {LoginInfo} from './login-info.model';

@Injectable()
export class AuthenticationApiService {
  public baseUrl = environment.backEndUrlPrefix + '/auth';

  constructor(private http: HttpClient) {
  }

  userStatus(): Observable<LoginInfo> {
    return this.http.get<LoginInfo>(this.baseUrl + '/userstatus');
  }

  recoveryPassword(account): Observable<LoginInfo> {
    return this.http.post<LoginInfo>(this.baseUrl + '/recovery_password?account=' + encodeURIComponent(account), '');
  }

  resetPassword(obj): Observable<LoginInfo> {
    return this.http.post<LoginInfo>(this.baseUrl + '/reset_password', '', {params: obj});
  }
}
